import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function BonusAlert({ amount }) {
  const { t } = useTranslation(['description']);

  return (
    <Alert severity="success">
      <AlertTitle>{t('payments.dashboard.bonus_alert.congrats')}</AlertTitle>
      {t('payments.dashboard.bonus_alert.description', {
        ns: 'description',
        amount,
      })}
    </Alert>
  );
}
